import { getFavoriteCount } from "@src/utils/favorite";

const countElement = document.querySelector(
  '.container-header-nav-item[data-name="shortlist"] [data-count]'
);

export default function updateHeaderShortlistCount() {
  if (countElement) {
    const count = getFavoriteCount("apartment") + getFavoriteCount("parking");
    countElement.setAttribute("data-count", count.toString());
    countElement.innerHTML = count.toString();
  }
}
